module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<bar params=\"\n    values: values,\n    markers: markers,\n    minRatio: 0\n\"></bar>\n";
